module.exports = __webpack_public_path__ + "assets/img/e33a-ky.svg";